module.exports = {
  submit: 'Send feedback & rating',
  feedback_is_send_to: 'Your feedback will be sent to %{appName}.',
  contact: 'Contact',
  your_feedback: 'Your feedback',
  rating: 'Rating',
  thanks_for_rating_us: 'Thank you for your feedback!',
  we_will_consider_it: 'We will take a moment to review your feedback.',
  title: 'Feedback / Rate the app',
  title_item_feedback: 'Report question / answer',
  submit_item_feedback: 'Send feedback',
  your_feedback_item_feedback: 'Your message',
  description_item_feedback: 'Please tell us about your issue with this content. If you like, you can also add links to relevant information.',
  feedback_item: {
    text: 'Do you want to share something with us?',
    link: 'Send us your feedback >',
  },
}
